import SpainContributionType from 'modules/contracts/store/models/SpainContributionType'

import { PayrollLegalEntityResource } from '../payrollLegalEntityResource'

export interface IContributionType {
  id: number
  legal_entity_id: number
  name: string
  default: boolean
  archived: boolean
}

class ContributionTypes extends PayrollLegalEntityResource<SpainContributionType> {
  get cacheKey(): string {
    return 'contributionTypes'
  }

  model() {
    return SpainContributionType
  }
}

export { ContributionTypes }
